var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63575 31.3229C8.22454 31.3229 7.83018 31.1596 7.53941 30.8688C7.24864 30.578 7.08529 30.1837 7.08529 29.7725L7.08529 8.06604C7.08529 7.65483 7.24864 7.26047 7.53941 6.9697C7.83017 6.67893 8.22454 6.51558 8.63575 6.51558L14.8376 6.51558C15.6939 6.51558 16.388 5.82142 16.388 4.96512C16.388 4.10883 15.6939 3.41467 14.8376 3.41467L8.63575 3.41467C7.40212 3.41467 6.21903 3.90472 5.34673 4.77702C4.47443 5.64933 3.98437 6.83242 3.98437 8.06604L3.98437 29.7725C3.98437 31.0061 4.47443 32.1892 5.34673 33.0615C6.21903 33.9338 7.40213 34.4238 8.63575 34.4238L14.8376 34.4238C15.6939 34.4238 16.388 33.7297 16.388 32.8734C16.388 32.0171 15.6939 31.3229 14.8376 31.3229L8.63575 31.3229Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5928 27.7685C25.1983 28.374 26.18 28.374 26.7855 27.7685L34.5378 20.0162C35.1432 19.4108 35.1432 18.4291 34.5378 17.8236L26.7855 10.0713C26.18 9.46579 25.1983 9.46579 24.5928 10.0713C23.9873 10.6768 23.9873 11.6585 24.5928 12.264L31.2487 18.9199L24.5928 25.5759C23.9873 26.1814 23.9873 27.163 24.5928 27.7685Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2852 18.9202C13.2852 19.7765 13.9793 20.4707 14.8356 20.4707L33.4411 20.4707C34.2974 20.4707 34.9916 19.7765 34.9916 18.9202C34.9916 18.0639 34.2974 17.3698 33.4411 17.3698L14.8356 17.3698C13.9793 17.3698 13.2852 18.064 13.2852 18.9202Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log-out.7b140701.svg";
export { ForwardRef as ReactComponent };